var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img col-sm-12"},[_c('img',{attrs:{"src":require("@/assets/IMG/Fondo_peq.png"),"alt":"Fondo"}}),_c('div',{staticClass:"tx-text text-center"},[_c('h1',{staticClass:"headline"},[_vm._v(" MY WORD ")])])])
}]

export { render, staticRenderFns }